<template>
  <div class="common-seach-wrap">
    <el-tabs v-model="activeName">
      <el-tab-pane label="极光场景" name="jgpush"></el-tab-pane>
      <el-tab-pane label="极光推送设置" name="appjiguang"></el-tab-pane>
      <el-tab-pane label="极光模板" name="jgtemplate"></el-tab-pane>
    </el-tabs>
    <jgpush v-if="activeName == 'jgpush'"></jgpush>
    <appjiguang v-if="activeName == 'appjiguang'"></appjiguang>
    <jgtemplate v-if="activeName == 'jgtemplate'"></jgtemplate>

  </div>
</template>
<script>
import jgpush from "../jgpush/index";
import appjiguang from "../appjiguang";
// import template from "../appjiguang";
import jgtemplate from "../template/index";

export default {
  components: {
    jgpush,
    appjiguang,
    jgtemplate
  },
  data() {
    return {
      activeName: "jgpush"
    };
  },
  methods: {}
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/appsetting/setjiguang/index.vue